import React from 'react';
import superagent from 'superagent';
import Autosuggest from 'react-autosuggest';
import TrieSearch from '@it-economia/trie-search';

const expandRegexes = [
	{ regex: /[á]/ig, alternate: 'a' },
	{ regex: /[éě]/ig, alternate: 'e' },
	{ regex: /[í]/ig, alternate: 'i' },
	{ regex: /[ó]/ig, alternate: 'o' },
	{ regex: /[úû]/ig, alternate: 'u' },
	{ regex: /[ý]/ig, alternate: 'y' },

	{ regex: /[č]/ig, alternate: 'c' },
	{ regex: /[ď]/ig, alternate: 'd' },
	{ regex: /[ň]/ig, alternate: 'n' },
	{ regex: /[ř]/ig, alternate: 'r' },
	{ regex: /[š]/ig, alternate: 's' },
	{ regex: /[ť]/ig, alternate: 't' },
	{ regex: /[ž]/ig, alternate: 'z' }
];

const splitOnRegEx = /[\s_()-]/g;

const Item = ({ fullName }) => fullName;

export default class Suggest extends React.Component {
	state = {
		name: '',
		suggestions: [],
		firstLetter: ''
	};

	createTrie() {
		return new TrieSearch('name', { splitOnRegEx, expandRegexes });
	}

	onFetch = ({ value = '' }) => {
		const firstLetter = (value[0] || '').toLowerCase();

		if (!firstLetter) {
			return this.setState({ firstLetter: '', suggestions: [] });
		}

		if (this.state.firstLetter === firstLetter) {
			return;
		}

		this.setState({ suggestions: [], firstLetter });

		superagent
			.get(`${this.props.rootUrl}suggest/${firstLetter}.json`)
			.then(response => {
				this.trie = this.createTrie();
				this.trie.addAll(response.body);
				this.setState(state => ({
					suggestions: this.trie.get(state.name)
						.sort((a, b) => a.name.length - b.name.length)
						.slice(0, this.props.limit)
				}));
			});
	};

	onClear = () => {
		this.setState({ name: '', suggestions: [] });
	};

	onInput = event => {
		const name = event.target.value || '';
		this.setState({
			name,
			suggestions: this.trie ? this.trie.get(name)
				.sort((a, b) => a.name.length - b.name.length)
				.slice(0, this.props.limit) : []
		});
	};

	onSubmit = event => {
		event.preventDefault();

		if (this.state.suggestions.length) {
			const suggestion = this.state.suggestions[0];
			this.onClear();
			this.props.onSelect(event, { suggestion });
		}
	}

	onSelect = (event, suggestion) => {
		event.preventDefault();
		this.onClear();
		this.props.onSelect(event, suggestion);
	}

	render() {
		return <form onSubmit={this.onSubmit}>
			<Autosuggest
				id="suggest"
				theme={this.props.theme}
				inputProps={{
					type: 'text',
					placeholder: 'Vyhledat obec...',
					value: this.state.name,
					onChange: this.onInput
				}}
				suggestions={this.state.suggestions}
				onSuggestionSelected={this.onSelect}
				onSuggestionsFetchRequested={this.onFetch}
				alwaysRenderSuggestions
				getSuggestionValue={Item}
				renderSuggestion={Item}
				focusInputOnSuggestionClick={false}
				onSuggestionsClearRequested={this.onClear}
			/>
		</form>;
	}

}

Suggest.defaultProps = {
	limit: 10
}
